import React from 'react';

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen" style={{ paddingTop: '120px' }}>
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="display-medium text-white mb-8">Privacy Policy</h1>
        
        <div className="network-card space-y-6">
          <section>
            <h2 className="heading-3 text-white mb-3">1. Information We Collect</h2>
            <p className="text-gray-300">
              We collect information that you provide directly to us, such as when you contact us via email or fill out forms on our website. 
              We also automatically collect certain information about your device when you use our website, including IP address, browser type, 
              and usage data through cookies and similar technologies.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">2. How We Use Your Information</h2>
            <p className="text-gray-300 mb-2">We use the information we collect to:</p>
            <ul className="list-disc list-inside text-gray-300 space-y-1 ml-4">
              <li>Provide, maintain, and improve our services</li>
              <li>Send you updates and notifications about AFCON 2025</li>
              <li>Respond to your comments and questions</li>
              <li>Analyze usage patterns and optimize user experience</li>
              <li>Serve relevant advertisements through Google AdSense</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">3. Cookies and Tracking</h2>
            <p className="text-gray-300">
              We use cookies and similar tracking technologies to track activity on our website and collect information. 
              Third-party services like Google AdSense also use cookies to serve ads based on your prior visits to our website 
              or other websites. You can instruct your browser to refuse all cookies or indicate when a cookie is being sent.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">4. Third-Party Services</h2>
            <p className="text-gray-300">
              Our website uses PropellerAds to display advertisements. They may use cookies to serve ads based on your visits 
              to this site and other sites on the Internet. We also embed content from YouTube and other official sources, which 
              may collect data according to their own privacy policies.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">5. Data Security</h2>
            <p className="text-gray-300">
              We implement appropriate security measures to protect your personal information. However, no method of transmission 
              over the Internet or electronic storage is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">6. Children's Privacy</h2>
            <p className="text-gray-300">
              Our website does not knowingly collect personal information from children under 13. If you are a parent or guardian 
              and believe your child has provided us with personal information, please contact us.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">7. Changes to This Policy</h2>
            <p className="text-gray-300">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy 
              on this page and updating the "Last Updated" date.
            </p>
          </section>

          <p className="text-gray-500 text-sm mt-8">
            Last Updated: January 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export const CookiePage = () => {
  return (
    <div className="min-h-screen" style={{ paddingTop: '120px' }}>
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="display-medium text-white mb-8">Cookie Policy</h1>
        
        <div className="network-card space-y-6">
          <section>
            <h2 className="heading-3 text-white mb-3">What Are Cookies?</h2>
            <p className="text-gray-300">
              Cookies are small text files that are placed on your computer or mobile device when you visit a website. 
              They are widely used to make websites work more efficiently and provide information to website owners.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">How We Use Cookies</h2>
            <p className="text-gray-300 mb-2">We use cookies for the following purposes:</p>
            <ul className="list-disc list-inside text-gray-300 space-y-1 ml-4">
              <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our website</li>
              <li><strong>Advertising Cookies:</strong> Used by Google AdSense to serve relevant ads</li>
              <li><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">Third-Party Cookies</h2>
            <p className="text-gray-300">
              We use PropellerAds for advertising, which uses cookies to serve ads based on your prior visits to our website 
              or other websites. PropellerAds' use of advertising cookies enables it and its partners to serve ads based on your visit 
              to our site and/or other sites on the Internet. You may opt out of personalized advertising by visiting 
              PropellerAds' Ads Settings.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">Managing Cookies</h2>
            <p className="text-gray-300">
              Most web browsers allow you to control cookies through their settings. You can set your browser to refuse cookies 
              or delete certain cookies. However, if you disable cookies, some features of our website may not function properly.
            </p>
          </section>

          <p className="text-gray-500 text-sm mt-8">
            Last Updated: January 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export const DMCAPage = () => {
  return (
    <div className="min-h-screen" style={{ paddingTop: '120px' }}>
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="display-medium text-white mb-8">DMCA Policy</h1>
        
        <div className="network-card space-y-6">
          <section>
            <h2 className="heading-3 text-white mb-3">Copyright Policy</h2>
            <p className="text-gray-300">
              We respect the intellectual property rights of others. Our website only embeds official video content from 
              authorized sources such as YouTube, CAF official channels, and licensed broadcasters. We do not host, upload, 
              or distribute any video files directly.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">Embedded Content</h2>
            <p className="text-gray-300">
              All video content on this website is embedded from official sources using legitimate embed codes provided by 
              the copyright holders. We provide links to official broadcasters and streaming services where users can watch 
              live matches legally.
            </p>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">DMCA Takedown Requests</h2>
            <p className="text-gray-300 mb-3">
              If you believe that content on our website infringes your copyright, please provide us with the following information:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-1 ml-4">
              <li>Your contact information (name, address, email, phone number)</li>
              <li>Description of the copyrighted work you claim has been infringed</li>
              <li>URL or location of the allegedly infringing content on our website</li>
              <li>A statement that you have a good faith belief that the use is not authorized</li>
              <li>A statement that the information in your notice is accurate</li>
              <li>Your physical or electronic signature</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-3 text-white mb-3">Counter-Notification</h2>
            <p className="text-gray-300">
              If you believe that content you posted was removed or disabled by mistake or misidentification, you may file a 
              counter-notification with us.
            </p>
          </section>

          <p className="text-gray-500 text-sm mt-8">
            Last Updated: January 2025
          </p>
        </div>
      </div>
    </div>
  );
};